import { Button, Flex, ModalV2, Text } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import { useRemoveUser } from "../../hooks";

type RemoveUserModalProps = {
  isOpen: boolean;
  onClose: () => void;
  userData: {
    id: string;
    name: string;
    email: string;
  };
  closeDrawer: () => void;
};

const RemoveUserModal = ({ userData, isOpen, onClose, closeDrawer }: RemoveUserModalProps) => {
  const { handleRemoveUser, loading } = useRemoveUser(userData?.id);

  const handleConfirm = async () => {
    await handleRemoveUser();
    onClose();
    closeDrawer();
  };

  return (
    <ModalV2
      data-testid="remove-user-modal"
      title="Delete user"
      description={userData?.name}
      show={isOpen}
      onHide={onClose}
      size="small"
    >
      <ModalV2.Body>
        <Text variant="regular-lg" marginBottom="md">
          Are you sure you want to delete {userData?.name} ({userData?.email}) from Canopy?
        </Text>
        <Text variant="regular-lg" marginBottom="md">
          {userData?.name} will lose access to all data and projects in Canopy.
        </Text>
        <Text variant="regular-lg" marginBottom="xl">
          Any active work assigned to {userData?.name} will be need to be unassigned.
        </Text>

        <Flex gap={SPACING.MEDIUM} justifyContent="end">
          <Button variant="neutral" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleConfirm}
            isLoading={loading}
            disabled={loading}
          >
            Delete user
          </Button>
        </Flex>
      </ModalV2.Body>
    </ModalV2>
  );
};

export default RemoveUserModal;
